import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "../components/TopBar";
import { useToast } from "../context/ToastContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Card, Col, Row, Form, Spinner, InputGroup } from "react-bootstrap";

const ContactInfo = () => {
  const { showToast } = useToast();

  const [contactInfo, setContactInfo] = useState({
    phone: "",
    email: "",
    address: "",
    linkedin: "",
    facebook: "",
    instagram: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/contact-info`);
        const data = await res.json();
        if (data) setContactInfo(data);
      } catch (err) {
        showToast("Failed to load contact info", "error");
      }
    };
    fetchContactInfo();
  }, [showToast]);

  const handleChange = (e) => {
    setContactInfo({ ...contactInfo, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/contact-info`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contactInfo),
      });

      if (res.ok) showToast("Contact info updated successfully", "success");
      else showToast("Failed to update contact info", "error");
    } catch (err) {
      showToast("Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4">
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1" style={{ marginLeft: "250px", minHeight: "100vh", backgroundColor: "#f5f7fa" }}>
        <TopBar />

        <div className="container-fluid py-4">
          {/* <h3 className="mb-4 text-dark fw-bold">Contact Information</h3> */}

          <Card className="shadow-sm border-0 rounded-4 p-4">
            <Form onSubmit={handleSubmit}>
              {/* Phone & Email */}
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group controlId="phone" className="mb-3">
                    <Form.Label className="fw-semibold">Phone</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>📞</InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={contactInfo.phone}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        required
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="email" className="mb-3">
                    <Form.Label className="fw-semibold">Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>✉️</InputGroup.Text>
                      <Form.Control
                        type="email"
                        name="email"
                        value={contactInfo.email}
                        onChange={handleChange}
                        placeholder="Enter email address"
                        required
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {/* Address */}
              <Form.Group controlId="address" className="mb-4">
                <Form.Label className="fw-semibold">Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={contactInfo.address}
                  onChange={handleChange}
                  placeholder="Enter full address"
                  className="border-1 rounded-3 shadow-sm"
                  required
                />
              </Form.Group>

              {/* Social Links */}
              <Row className="mb-4">
                <Col md={4}>
                  <Form.Group controlId="linkedin" className="mb-3">
                    <Form.Label className="fw-semibold">LinkedIn</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>🔗</InputGroup.Text>
                      <Form.Control
                        type="url"
                        name="linkedin"
                        value={contactInfo.linkedin}
                        onChange={handleChange}
                        placeholder="LinkedIn profile URL"
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="facebook" className="mb-3">
                    <Form.Label className="fw-semibold">Facebook</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>🔗</InputGroup.Text>
                      <Form.Control
                        type="url"
                        name="facebook"
                        value={contactInfo.facebook}
                        onChange={handleChange}
                        placeholder="Facebook profile URL"
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="instagram" className="mb-3">
                    <Form.Label className="fw-semibold">Instagram</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>🔗</InputGroup.Text>
                      <Form.Control
                        type="url"
                        name="instagram"
                        value={contactInfo.instagram}
                        onChange={handleChange}
                        placeholder="Instagram profile URL"
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {/* Submit */}
              <Button
                type="submit"
                className="px-5 py-2 rounded-pill"
                style={{ backgroundColor: "#4a6cf7", border: "none" }}
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Update Contact Info"}
              </Button>
            </Form>
          </Card>
        </div>
      </div>
    </div>
    </div>

  );
};

export default ContactInfo;
